import { ConfigurationDomain } from 'constants/ConfigurationDomain';
import { MANAGEMENT_ROUTE } from '../domains';

export const JOINT_COMMISSIONS_ROUTE = `${MANAGEMENT_ROUTE}/${ConfigurationDomain.JOINT_COMMISSIONS}`;

export const JointCommissionsTab = {
  PARITAIR_COMITE: 'paritair-comite',
  WAGE_COMPONENTS: 'wage-components',
  WAGE_INDEXATION: 'wage-indexation',
};

export const PARITAIR_COMITE_DETAILS_SEGMENT = 'paritair-comite-details';

export const buildParitairComiteDetailsRoute = (paritairComiteId: number | string): string =>
  `${JOINT_COMMISSIONS_ROUTE}/${PARITAIR_COMITE_DETAILS_SEGMENT}/${paritairComiteId}/general`;

export const NEW_PARITAIR_COMITE_ID = 'new';

export const getParitairComiteDetailsIdFromPath = (pathname: string): string | undefined => {
  if (!pathname.startsWith(`${JOINT_COMMISSIONS_ROUTE}/`)) {
    return undefined;
  }
  const [segment, paritairComiteId] = pathname.slice(JOINT_COMMISSIONS_ROUTE.length + 1).split('/');
  return segment === PARITAIR_COMITE_DETAILS_SEGMENT && paritairComiteId ? paritairComiteId : undefined;
};
